export default {
  name: 'MemberList',
  props: {
    hasDateRange: {
      default: false,
      type: Boolean,
    },
    records: {
      default: () => [],
      type: Array,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    showTitle: {
      default: true,
      type: Boolean,
    },
  },
  methods: {
    columnThAttrs() {
      return {
        class: 'text-xs',
      };
    },
    getUnreceivedColor(order) {
      const { unreceived = 0 } = order || {};
      return +unreceived ? 'text-red-500' : 'text-black';
    },
  },
};
